const prixtel = {
  brand: 'prixtel',
  production: true,
  cgvUrl: 'https://cdn.prixtel.com/sources/pxl/files/pdf/documentation/commun/cgv/196/CGV_CGA_Prixtel_01_2026.pdf',
  cga: null,
  gti: 'https://short.prixtel.com/gtci',
  apiUrl: 'https://espaceclient.prixtel.com/api/',
  extEcApiUrl: 'https://extec.prixtel.com/api/',
  apiPaymentUrl: 'https://sps.prixtel.com/api',
  fileApiUrl: 'https://external-pxl-aws-s3.prixtel.com/api/',
  iaApiUrl: 'https://ia-chat-bot.prixtel.com/api/',
  insuranceNotice: 'https://cdn.prixtel.com/media/pdf/documentation/assurance/notice_assurance.pdf',
  insuranceUrl: 'https://www.prixtel.com/assurance-mobile',
  assistanceUrl : 'https://assistance.prixtel.com',
  dimeloSSO : 'https://assistance-identification.prixtel.com',
  supportingDocumentsBucketSlug: 'missions_bucket',
  customerFilesBucketSlug: 'bucket_customers_files',
  supportingDocumentsFileTypeSlug: 'supporting_documents',
  detailedBillFileTypeSlug: 'detailed_bill',
  cookiesDomain: '.prixtel.com',
  ogoneUrl: 'https://secure.ogone.com/Tokenization/HostedPage',
  ogonePSPID: 'prixtelcepac',
  url: 'https://espaceclient.prixtel.com',
  host: 'ec',
  vitrineUrl: 'https://www.prixtel.com',
  minOfferId: 502,
  proEmail: 'pro@prixtel.com',
  secretKey: '5c7e9ea18b694d0106c4649a15ef18ab',
  ipAddressApi: 'https://api.ipify.org/?format=json',
  stripeToken: 'pk_live_51IZBCDKnFXDP6R9LG2MSLa0nPwUxFLmowGc9XTlSl8x3HJiZPLW63IaEBqhMOMYSYNNARyA9RDLtElS82OPruHLj0077StpZLV',
  iaChatbotUrl: 'https://ia-chatbot-web.prixtel.com/',
  landlineSubscriptionPurchaseOrderFileTypeSlug: 'landline_subscription_purchase_order',
  landlineSubscriptionKbisFileTypeSlug: 'landline_subscription_kbis',
  voucherFileTypeSlug: 'return_label',
  customerContractFileTypeSlug: 'customers_contract',
  captchaKey: '6Lf3dd8pAAAAADXPZF7rB_cziBB_9Tfek1rPokth',
  identityFrontFileTypeSlug: 'identity_front',
  identityBackFileTypeSlug: 'identity_back',
  selfieWithIdentityFileTypeSlug: 'selfie_with_identity',
};

const coriolis = {
  brand: 'coriolis',
  production: true,
  cgvUrl: 'https://cdn.coriolistele.com/sources/coriolis/files/pdf/documentation/commun/cgv_gp_decembre.pdf',
  cga: 'https://cdn.coriolistele.com/sources/coriolis/files/pdf/documentation/commun/2026-05-CGA-Mobile-Coriolis-GP.pdf',
  gti: null,
  apiUrl: 'https://espaceclient.coriolis.com/api/',
  extEcApiUrl: 'https://extec.coriolis.com/api/',
  apiPaymentUrl: 'https://sps.coriolis.com/api',
  fileApiUrl: 'https://external-pxl-aws-s3.coriolis.com/api/',
  iaApiUrl: 'https://ia-chat-bot.coriolis.com/api/',
  insuranceNotice: 'https://cdn.coriolistele.com/media/pdf/documentation/assurance/notice_assurance.pdf',
  insuranceUrl: 'https://www.coriolis.com/assurance-mobile',
  assistanceUrl : 'https://assistance.coriolis.com',
  dimeloSSO : 'https://coriolis.users.dimelo.info',
  supportingDocumentsBucketSlug: 'missions_bucket',
  customerFilesBucketSlug: 'bucket_customers_files',
  supportingDocumentsFileTypeSlug: 'supporting_documents',
  detailedBillFileTypeSlug: 'detailed_bill',
  cookiesDomain: '.coriolis.com',
  ogoneUrl: 'https://ogone.test.v-psp.com/Tokenization/HostedPage',
  ogonePSPID: 'prixteltech2',
  url: 'https://espaceclient.coriolis.com',
  host: 'ec',
  vitrineUrl: 'https://www.coriolis.com',
  minOfferId: 502,
  proEmail: 'pro@coriolis.com',
  secretKey: '5c7e9ea18b694d0106c4649a15ef18ab',
  ipAddressApi: 'https://api.ipify.org/?format=json',
  stripeToken: 'pk_live_51Nq1G7Et4mE2kSnZ1dmcsMK3FOebJIGtPrUhkXcilqofHEmQDuqWDqD359jPU8zImmxirLAhpEakxz0jn1BQbgHe00BPfEPoDF',
  iaChatbotUrl: 'https://ia-chatbot-web.coriolis.com/',
  landlineSubscriptionPurchaseOrderFileTypeSlug: 'landline_subscription_purchase_order',
  landlineSubscriptionKbisFileTypeSlug: 'landline_subscription_kbis',
  voucherFileTypeSlug: 'return_label',
  customerContractFileTypeSlug: 'customers_contract',
  captchaKey: '6LfJht8pAAAAAI5hKw33_AtXjC2F4QXsWxyYcScl',
  identityFrontFileTypeSlug: 'identity_front',
  identityBackFileTypeSlug: 'identity_back',
  selfieWithIdentityFileTypeSlug: 'selfie_with_identity',
};

const lacarte = {
  brand: 'lacarte',
  production: true,
  cgvUrl: null,
  cga: null,
  gti: null,
  apiUrl: 'https://my.sfr-discover.fr/api/',
  extEcApiUrl: 'https://extec.sfr-discover.fr/api/',
  apiPaymentUrl: 'https://sps.sfr-discover.fr/api',
  fileApiUrl: 'https://external-pxl-aws-s3.sfr-discover.fr/api/',
  iaApiUrl: 'https://ia-chat-bot.sfr-discover.fr/api/',
  insuranceNotice: 'https://cdn.sfr-discover.fr/media/pdf/documentation/assurance/notice_assurance.pdf',
  insuranceUrl: 'https://www.beta.sfr-la-carte.info/assurance-mobile',
  assistanceUrl : 'https://sfr-discover.fr/aide',
  dimeloSSO : 'https://assistance-identification.sfr-discover.fr',
  supportingDocumentsBucketSlug: 'missions_bucket',
  customerFilesBucketSlug: 'bucket_customers_files',
  supportingDocumentsFileTypeSlug: 'supporting_documents',
  detailedBillFileTypeSlug: 'detailed_bill',
  cookiesDomain: '.sfr-discover.fr',
  ogoneUrl: 'https://ogone.test.v-psp.com/Tokenization/HostedPage',
  ogonePSPID: 'prixteltech2',
  url: 'https://my.sfr-discover.fr',
  host: 'ec',
  vitrineUrl: 'https://www.sfr-discover.fr',
  minOfferId: 502,
  proEmail: 'pro@sfr-discover.fr',
  secretKey: '5c7e9ea18b694d0106c4649a15ef18ab',
  ipAddressApi: 'https://api.ipify.org/?format=json',
  stripeToken: 'pk_live_51R3wQlCmB3A1WT0ZJPs12Mx2tNz4LzfILL1xzZhHFnkuasdv7LlQ1f5JXRScQe6Kze0cJukaeb9515N8X1sg4O1P00T0ViNf4J',
  iaChatbotUrl: 'https://ia-chatbot-web.sfr-discover.fr/',
  landlineSubscriptionPurchaseOrderFileTypeSlug: 'landline_subscription_purchase_order',
  landlineSubscriptionKbisFileTypeSlug: 'landline_subscription_kbis',
  voucherFileTypeSlug: 'return_label',
  customerContractFileTypeSlug: 'customers_contract',
  captchaKey: '6LcMQBArAAAAALR6uTnk41ygPq9d8Z-Jgr8IdaxT',
  identityFrontFileTypeSlug: 'identity_front',
  identityBackFileTypeSlug: 'identity_back',
  selfieWithIdentityFileTypeSlug: 'selfie_with_identity',
};

export const environment = {
  production: false,
  data: (window.location.hostname.includes('corio')) ? coriolis : window.location.hostname.includes('sfr') ? lacarte : prixtel,
};
